import { Component } from 'react'
import { Link } from 'react-router-dom'
import { ErrorMessage, emptyField, errorsLength, formatErrors, validatePasswordConfirmation } from '../../../../insfrastructure/utils/form-validators'
import { requestOTP } from '../../../../insfrastructure/services/auth'
import { parseJwt } from '../../../../insfrastructure/utils/JWTParser'
import { retrieveCandidate } from '../../../../insfrastructure/services/candidates'
import { retrieveCompanyManager } from '../../../../insfrastructure/services/companies'
import { withRouter } from '../../../../insfrastructure/utils/with-router-component'
import { Input } from '../../../components/input'
import { SubmitBtn } from '../../../components/submit'
import ResponseModal from '../../../components/response-modal'
import { PasswordRequirements } from '../../../components/password-requirements'
import forgotPasswordImg from '../../../../assets/images/forgot_password.png'
import checkImg from '../../../../assets/images/check.png'
import CheckboxInput from '../../../components/checkbox'
import './styles.sass'


class ResetPassword extends Component<any> {
    state: any = {
        form: {
            new_password1: '',
            new_password2: ''
        },
        formErrors: {},
        loading: false,
        sended: false,
        userdata: {}
    }

    async componentDidMount() {
        const parsedJWT = parseJwt(localStorage.getItem('auth_token') + '');

        if (parsedJWT) {
            let userdata: any = {};

            if (parsedJWT.candidate_id) {
                userdata = await retrieveCandidate();
            } else {
                userdata = await retrieveCompanyManager();
                userdata.email = userdata.manager_email;
            };

            this.setState({ userdata });
        };
    }

    onSubmit = async () => {
        this.setState({ formErrors: {} });

        let fields: Record<string, any> = {
            new_password1: [emptyField(this.state.form.new_password1, 'string')],
            new_password2: [validatePasswordConfirmation(this.state.form.new_password1, this.state.form.new_password2)]
        };

        if (!this.state.userdata.email) {
            fields['email'] = [emptyField(this.state.form.email, 'string')];
        } else {
            fields['terms_and_conditions'] = [emptyField(this.state.form.terms_and_conditions, 'string')];
        };

        const errors = formatErrors(fields);

        this.setState({ formErrors: errors });

        if(errorsLength(errors) > 0 || !this.state.isPasswordValidated) return;

        this.setState({ loading: true });

        console.log(this.props);
        console.log(this.state);

        await requestOTP({ email: !this.state.userdata.email ? this.state.form.email : this.state.userdata.email });

        try {
            setTimeout(() => {
                this.setState({ sended: true, loading: false });
                this.props.navigate('/validate-token', {
                    state: {
                        email: !this.state.userdata.email ? this.state.form.email : this.state.userdata.email,
                        new_password1: this.state.form.new_password1,
                        new_password2: this.state.form.new_password2
                    }
                });
            });
        } catch (error) {
            let responseData = {
                type: 'error',
                title: 'Ocorreu um erro inesperado',
                text: () => <></>
            };
        
            localStorage.removeItem('user_id');
            localStorage.removeItem('candidate_id');
            localStorage.removeItem('manager_id');
            localStorage.removeItem('legacy_password_login');
            localStorage.removeItem('auth_token');
            this.setState({ responseData, loading: false });
        };
    }

    render() {
        return (
            <div className='reset-password unlogged-page'>
                <div className='content'>
                    <div className='block'>
                        {window.innerWidth > 1000 &&
                        <div className='img-container'>
                            <img src={forgotPasswordImg} alt='forgot-password-image' />
                        </div>}
                        {
                            !this.state.sended ?
                            <div className='block-content not-sended'>
                                <div className='text'>
                                    <h3>Olá{this.state.userdata?.full_name ? ' '+this.state.userdata?.full_name?.split(' ')[0] : ''}! A seguir altere sua senha</h3>
                                </div>
                                <div className='form'>
                                    {
                                        !this.state.userdata.email &&
                                        <>
                                            <Input
                                            name='email'
                                            label='Email'
                                            placeholder='Insira seu email'
                                            onChange={e => this.setState({ form: { ...this.state.form, email: e } })}/>
                                            <ErrorMessage errors={this.state.formErrors['email']} />
                                        </>
                                    }
                                    <Input
                                    name='new_password1'
                                    label='Nova Senha'
                                    type='password'
                                    placeholder='Insira sua nova senha'
                                    onChange={e => this.setState({ form: {...this.state.form, new_password1: e} })}/>
                                    <ErrorMessage errors={this.state.formErrors['new_password1']} />
                                    <Input
                                    name='new_password2'
                                    label='Confirme sua Nova Senha'
                                    type='password'
                                    placeholder='Insira sua nova senha'
                                    onChange={e => this.setState({ form: {...this.state.form, new_password2: e} })}/>
                                    <ErrorMessage errors={this.state.formErrors['new_password2']} />
                                    {
                                        this.state.userdata.email && 
                                        <div className='terms-and-conditions-container'>
                                            <CheckboxInput
                                            name='terms_and_conditions'
                                            label={
                                              () => (
                                                <div>
                                                  Aceito a{' '}
                                                  <a 
                                                    href='https://staging.empregamecanico.com.br/privacy-policy' 
                                                    target='_blank' 
                                                    rel='noopener noreferrer'
                                                    style={{ color: '#FFD700', textDecoration: 'underline', fontWeight: '600' }}
                                                  >
                                                    Política de Privacidade
                                                  </a>
                                                </div>
                                              )
                                            }
                                            checked={this.state.form.terms_and_conditions}
                                            onChange={e => this.setState({ form: { ...this.state.form, terms_and_conditions: e } })}/>
                                            <ErrorMessage errors={this.state.formErrors['terms_and_conditions']} />
                                        </div>
                                    }
                                    <PasswordRequirements
                                    password={this.state.form.new_password1}
                                    email={!this.state.userdata.email ? this.state.form.email : this.state.userdata.email}
                                    isPasswordValidated={isPasswordValidated => this.setState({ isPasswordValidated })}/>
                                </div>
                                {/* <p className='bottom-text'>Ao <b>confirmar</b>, sua <b>senha</b> será alterada.</p> */}
                                <SubmitBtn className='secondary' text='Confirmar' loadingText='Enviando...' loading={this.state.loading} onSubmit={this.onSubmit} />
                            </div> :
                            <div className='block-content sended'>
                                <div className='text'>
                                    <img className='check' src={checkImg} alt='check-image' />
                                    <h3>Senha alterada com sucesso!</h3>
                                </div>
                                <Link to='/login'><SubmitBtn className='secondary' text='OK' /></Link>
                            </div>
                        }
                    </div>
                </div>
                <ResponseModal
                render={this.state.responseData}
                type={this.state.responseData?.type}
                title={this.state.responseData?.title}
                text={this.state.responseData?.text}
                onClose={() => 
                    this.props.navigate('/login')
                } />
            </div>
        )
    }
}

export default withRouter(ResetPassword);